/* eslint-disable max-len */
import * as React from 'react';
import { SVGProps, useMemo } from 'react';
import { getIconGradientColors } from './colorUtils';

type SubscriptionsColorableProps = SVGProps<SVGSVGElement> & {
  color?: string;
};

const SubscriptionsColorable = ({ color, ...props }: SubscriptionsColorableProps) => {
  const gradientId = useMemo(
    () => `subscriptions_colorable_${Math.random().toString(36).substr(2, 9)}`,
    [],
  );
  const { primary, secondary } = getIconGradientColors('Subscriptions', color);

  return (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="24" cy="24" r="24" fill={`url(#${gradientId})`} />
      <g transform="translate(8.328, 7.274)" stroke="#F7F5F8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none">
        <path d="M28.5305 8.13168C32.4225 14.6336 30.9343 23.3387 24.678 27.9138C18.4575 32.463 9.72345 31.3162 4.63414 25.7666" />
        <path d="M2.68023 23.0982C-1.04159 16.6261 0.480266 8.06331 6.66465 3.54095C12.9031 -1.02111 21.6687 0.144116 26.7522 5.73624" strokeDasharray="2 4" />
        <path d="M26.33 2.50279L26.8051 5.81611L23.536 5.47653" />
        <path d="M5.01112 28.9007L4.53599 25.5874L7.80466 25.927" />
      </g>
      <g transform="translate(18.88, 15.96)" stroke="#F7F5F8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none">
        <path d="M0.75 7.12506H6.11932" />
        <path d="M9.1875 12H0.75C2.06095 12 3.1235 10.9209 3.1235 9.5889V3.6963C3.1235 2.06856 4.42157 0.75 6.02334 0.75C6.7928 0.75 7.53044 1.05985 8.07421 1.6125" />
      </g>
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="43.5" y2="48" gradientUnits="userSpaceOnUse">
          <stop stopColor={primary} />
          <stop offset="1" stopColor={secondary} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default SubscriptionsColorable;
